import React from 'react';
import { useDispatch } from 'react-redux';
import { setSidebar } from "../../../slices/slices";
import {
  FaUser,
  FaBell,
  FaCog,
  FaSignOutAlt,
  FaMoneyCheckAlt,
} from 'react-icons/fa';
import { LuHistory } from "react-icons/lu";
import { BiSupport } from "react-icons/bi";
import { FaAngleRight } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import './headerNew1.scss';

const menuItems = [
  { icon: <FaUser />, label: 'Profile', path: "/personal-data" },
  { icon: <FaBell />, label: 'Notifications', path: "/all-notifications" },
  { icon: <FaCog />, label: 'Settings', path: "/alert-panel" },
  { icon: <FaSignOutAlt />, label: 'Logout', path: "#" },
];

const shortLinks = [
  { icon: <FaMoneyCheckAlt />, label: "Single Transfer", path: "/new-payment" },
  { icon: <LuHistory />, label: "Transactions", path: "/balance-and-movements" }
];

export default function RightSidebar({ showSidebar, setShowSidebar, isMobile, user }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const logOut = () => {
    localStorage.removeItem("isClient");
    localStorage.removeItem("auth_client");
    navigate("/login");
  };

  return (
    <>
      {showSidebar && (
        <div className="sidebar-backdrop" onClick={() => setShowSidebar(false)} />
      )}

      <div className={`sidebar ${showSidebar ? 'open' : ''} ${isMobile ? 'mobile' : 'desktop'}`}>
        <div className="sidebar-header">
          <span>Welcome</span>
          <h5>{user?.first_name} {user?.last_name}</h5>
        </div>

        <div className="sidebar-menu">
          {menuItems.map((item, idx) => (
            item.label === 'Logout' ? (
              <div key={idx} className="sidebar-item" onClick={() => logOut()}>
                <span className="sidebar-icon">{item.icon}</span>
                <span>{item.label}</span>
              </div>
            ) : (
              <div key={idx} className="sidebar-item" onClick={() => { dispatch(setSidebar(false)); navigate(item.path); }}>
                <span className="sidebar-icon">{item.icon}</span>
                <span>{item.label}</span>
              </div>
            )
          ))}
        </div>

        {showSidebar && (
          <div className="sidebar-menu px-3 mt-4">
            <h6>SHORT LINKS</h6>
            {shortLinks.map((item, idx) => (
              <div key={idx} className="sidebar-item" onClick={() => { dispatch(setSidebar(false)); navigate(item.path); }}>
                <span className="sidebar-icon">{item.icon}</span>
                <span>{item.label}</span>
              </div>
            ))}

          </div>
        )}

        <div className="support-textabove">
          <span>Need Help?</span>
        </div>
        <div className="sidebar-support" onClick={() => { dispatch(setSidebar(false)); navigate('/request-appointment'); }}>
          <div className="sidebar-item">
            <span className="sidebar-icon"><BiSupport /></span>
            <span className="support-text">Contact Support</span>
            <span className="ml-auto"><FaAngleRight /></span>
          </div>
        </div>

      </div>
    </>
  );
}
